import { Box } from '@mui/material';
import { pdvScale } from './pdvScale';

// Decoração do tema Ardósia (petroleo) — mesma filosofia da
// LoginTechDecoration/PDVBasicoDecoration/PDVOceanDecoration/
// PDVGrafiteDecoration/PDVAzulDecoration (100% CSS/MUI, sem imagem/PNG/SVG):
// só linear-gradient, radial-gradient e mask-image, então fica nítido em
// qualquer resolução. Dois componentes aqui — um pro FUNDO geral do PDV
// (mesma linguagem visual do header, com metade da intensidade) e outro só
// pro HEADER (mosaico diagonal mais forte + pontinhos numa área específica,
// atrás da logo/relógio). Nenhum dos dois entra na listagem, subtotal,
// inputs ou cards — só no header e no fundo geral, como pedido.

// ─── FUNDO GERAL DO PDV ─────────────────────────────────────────────────
export const PDVPetroleoDecoration: React.FC = () => (
  <Box sx={{ position: 'absolute', inset: 0, overflow: 'hidden', zIndex: 0, pointerEvents: 'none' }}>
    {/* Faixas diagonais grandes, bem discretas (opacidade entre 0.025 e
        0.03) — a mesma linguagem do header, só que bem mais fraca aqui. */}
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        background: `
          linear-gradient(135deg, transparent 0%, transparent 8%, rgba(31, 181, 193, 0.025) 8%, rgba(31, 181, 193, 0.025) 14%, transparent 14%),
          linear-gradient(315deg, transparent 0%, transparent 7%, rgba(31, 181, 193, 0.03) 7%, rgba(31, 181, 193, 0.03) 13%, transparent 13%)
        `,
      }}
    />

    {/* Pontilhado só nos cantos (mask), não no meio — onde ficam carrinho/pesquisa. */}
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        opacity: 0.42,
        backgroundImage: 'radial-gradient(circle, rgba(41, 191, 201, 0.15) 1.3px, transparent 1.6px)',
        backgroundSize: `${pdvScale(20)} ${pdvScale(20)}`,
        maskImage: 'linear-gradient(135deg, #000 0%, transparent 22%, transparent 78%, #000 100%)',
        WebkitMaskImage: 'linear-gradient(135deg, #000 0%, transparent 22%, transparent 78%, #000 100%)',
      }}
    />
  </Box>
);

// ─── HEADER ─────────────────────────────────────────────────────────────
// Renderizada DENTRO do AppBar, como primeiro filho (antes do Toolbar) —
// ver Pdv.tsx. O Toolbar (logo/data/relógio) precisa de position:'relative'
// + zIndex maior que esta decoração pra ficar sempre por cima.
export const PDVPetroleoHeaderDecoration: React.FC = () => (
  <Box sx={{ position: 'absolute', inset: 0, overflow: 'hidden', zIndex: 0, pointerEvents: 'none' }}>
    {/* Mosaico diagonal — duas faixas translúcidas que se repetem a cada
        420px (background-size menor que a largura do header + repeat
        padrão do CSS = ladrilho automático, sem imagem nenhuma). */}
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        opacity: 0.85,
        backgroundImage: `linear-gradient(
          135deg,
          transparent 0%,
          transparent 18%,
          rgba(74, 215, 221, 0.08) 18%,
          rgba(74, 215, 221, 0.08) 26%,
          transparent 26%,
          transparent 42%,
          rgba(255, 255, 255, 0.025) 42%,
          rgba(255, 255, 255, 0.025) 51%,
          transparent 51%
        )`,
        backgroundSize: `${pdvScale(420)} 100%`,
      }}
    />

    {/* Pontinhos tecnológicos — só numa faixa vertical à esquerda/centro do
        header (não atrás da logo nem do relógio), esmaecendo em elipse. */}
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: '22%',
        width: pdvScale(320),
        height: '100%',
        opacity: 0.55,
        backgroundImage: 'radial-gradient(circle, rgba(58, 216, 221, 0.22) 1.4px, transparent 1.7px)',
        backgroundSize: `${pdvScale(15)} ${pdvScale(15)}`,
        maskImage: 'radial-gradient(ellipse at center, #000 0%, transparent 72%)',
        WebkitMaskImage: 'radial-gradient(ellipse at center, #000 0%, transparent 72%)',
      }}
    />
  </Box>
);
